import { render, staticRenderFns } from "./gaokaobaike.vue?vue&type=template&id=66b3774e&scoped=true"
import script from "./gaokaobaike.vue?vue&type=script&lang=js"
export * from "./gaokaobaike.vue?vue&type=script&lang=js"
import style0 from "./gaokaobaike.vue?vue&type=style&index=0&id=66b3774e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b3774e",
  null
  
)

export default component.exports